import { useTranslation } from 'react-i18next';
import { CONTACTO, GRUPOSAESA, HERRAMIENTAS, INDICADORES, INVERSIONISTA, QUEINESOMOS } from 'root-page';
import useStyles from './TopHeaderStyles';

const TopHeader = ({ className }: { className: string }) => {
  /**
   * translate
   */
  const { t } = useTranslation();

  /**
   * Arreglo que contiene menu de navegacion de menu tope del header
   */
  const menuNavegacion = [
    {
      id: 0,
      option: t('tracking:paginas.tracking.home.menu.grupoSaesa'),
      url: GRUPOSAESA,
    },
    {
      id: 1,
      option: t('tracking:paginas.tracking.home.menu.quienesSomos'),
      url: QUEINESOMOS,
    },
    {
      id: 2,
      option: t('tracking:paginas.tracking.home.menu.inversionistas'),
      url: INVERSIONISTA,
    },
    {
      id: 3,
      option: t('tracking:paginas.tracking.home.menu.indicadores'),
      url: INDICADORES,
    },
    {
      id: 4,
      option: t('tracking:paginas.tracking.home.menu.herramientas'),
      url: HERRAMIENTAS,
    },
    {
      id: 5,
      option: t('tracking:paginas.tracking.home.menu.contacto'),
      url: CONTACTO,
    },
  ];

  const styles = useStyles();

  return (
    <section className={className}>
      <section className={styles.contenedorHeader}>
        <ul className={styles.menuRoot}>
          {menuNavegacion.map(item => (
            <li key={item.option} className={styles.item}>
              <a className={styles.link} href={item.url} target="_blank" rel="noopener noreferrer">
                {item.option}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </section>
  );
};

export default TopHeader;
